<template>
    <div style="background-color:#F8F8F8;overflow: hidden;">
        <div class="login_header" style="background-color: #fff;">
            <div class="logo">
                <img src="../../assets/img/logo.png" alt="" style="width: 100%;height: 100%;">
            </div>
            <el-button class="dengluBtn" @click="backBtn">{{ $t('meg.loginPage') }}</el-button>
        </div>
        <div class="trends">
            <p style="font-size: 57px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">
                {{ $t('meg.userregistration') }}</p>
            <p
                style="font-size: 20px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #FFFFFF;margin-top: 18px;">
                {{ $t('meg.fill') }}</p>
        </div>
        <div style="margin: 35px 440px;">
            <div class="kehuzhuce">{{ $t('meg.Customer') }}</div>
            <div class="information">
                <h1 class="title">{{ $t('meg.information') }}</h1>
                <div style="margin-top: 28px;margin-left: 60px;">
                    <el-form :label-width="getLabelWidth()" label-position="left" :rules="rules" :model="registerForm">
                        <el-form-item prop="useName" :label="$t('meg.user')" required>
                            <el-input v-model="registerForm.useName" />
                        </el-form-item>
                        <el-form-item prop="password" :label="$t('meg.password')" required>
                            <el-input type="password" v-model="registerForm.password" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.confirmPassword')" required prop="confirmPassword">
                            <el-input type="password" v-model="registerForm.confirmPassword" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.tephone')" required prop="phone">
                            <el-input v-model="registerForm.phone" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.email')" required prop="email">
                            <el-input v-model="registerForm.email" />
                            <el-button @click="sendVerificationCode" :disabled="!canSendCode" class="yanzhengBtn">{{
                                canSendCode ? '发送验证码' :
                                `重新发送(${countdown}s)` }}</el-button>
                        </el-form-item>
                        <el-form-item label="验证码" required prop="code">
                            <el-input style="width: 144px;" v-model="registerForm.code" />
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div>
            </div>
            <!-- <div class="information" style="margin-top: 12px;">
                <h1 class="title">客户信息</h1>
                <div style="margin-top: 28px;margin-left: 60px;">
                    <el-form :label-width="getLabelWidth2()" :rules="rules" label-position="left" :inline="true"
                        :model="registerForm" style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                        <el-form-item :label="$t('meg.companyName')" required prop="compantName">
                            <el-input v-model="registerForm.compantName" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.companyAlias')">
                            <el-input v-model="registerForm.companyAlias" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.companyAbbreviation')">
                            <el-input v-model="registerForm.companyAbbreviation" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.country')" required prop="country">
                            <el-select v-model="registerForm.country" class="m-2" placeholder="选择国家">
                                <el-option-group v-for="group in country" :key="group.label" :label="group.label">
                                    <el-option v-for="item in group.options" :key="item.value" :label="item.label"
                                        :value="item.label"></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('meg.companyWebsite')">
                            <el-input v-model="registerForm.companyWebsite" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.contactInformation')" required prop="contactInformation">
                            <el-input v-model="registerForm.contactInformation" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.companyAddress')" required prop="companyAddress">
                            <el-input style="width: 700px;" v-model="registerForm.companyAddress" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.remarks')">
                            <el-input style="width: 700px;" v-model="registerForm.remarks" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.companyLogo')" required style="margin-top: 18px;" prop="logo">
                            <div style="display: flex;flex-direction: column;">
                                <el-upload v-model="registerForm.logo" class="upload-demo"
                                    :headers="{ Authorization: acctoken }" :action="uploadUrl" :before-upload="beforeUpload"
                                    :limit="1" :accept="'image/jpeg,image/png'" :on-success="handleSuccess"
                                    :on-exceed="handleExceed" :on-error="handleError">
                                    <el-button class="upload">{{ $t('meg.upload') }}</el-button>
                                    <p
                                        style="font-size: 14px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;margin-left: 10px;">
                                        {{ $t('meg.exceed') }}</p>
                                </el-upload>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div> -->
            <div class="register_bottom">
                <el-button class="shenheBtn" @click="registerBtn">{{ $t('meg.Submit') }}</el-button>
                <div style="display: flex;margin-top: 32px;margin-left: 27px;">
                    <img src="../../assets/img/tishi.png" alt="" style="width: 16px;height: 16px;margin-top: 3px;">
                    <p
                        style="font-size: 16px;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #002FA7;margin-left: 3px;">
                        {{ $t('meg.result') }}</p>
                </div>
            </div>
            <div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { register, selectUserName, sendCode } from "@/api/login.js"
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';
const router = useRouter()
const uploadUrl = ref('/dev-api' + '/file/upload')
const fileList = ref([]);
const canSendCode = ref(true)
const countdown = ref(60)
const tip = ref("")
const registerForm = reactive({
    useName: "",
    password: "",
    confirmPassword: "",
    phone: "",
    email: "",
    code: "",

})
const acctoken = ref(localStorage.getItem("access_token"))

const getLabelWidth = () => {
    const lang = localStorage.getItem('selectedLanguage');
    // 根据不同语言设置不同的 label-width
    return lang === 'en' ? 'auto' : '100px';
}
const getLabelWidth2 = () => {
    const lang = localStorage.getItem('selectedLanguage');
    // 根据不同语言设置不同的 label-width
    return lang === 'en' ? 'auto' : '90px';
}

const validateConfirmPassword = async (rule, value) => {
    if (value !== registerForm.password) {
        throw new Error('两次输入密码不一致');
    }
};

const rules = {
    useName: [{ required: true, message: '请输入用户名', trigger: 'blur' },
    {
        validator: async (rule, value) => {
            // Check if the username already exists
            const response = await selectUserName(value);
            if (response.data.code === 500) {
                return Promise.reject(response.data.msg);
            } else {
                return Promise.resolve();
            }
        },
        trigger: 'blur'
    }
    ],
    password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, message: '密码长度至少为6位', trigger: 'blur' },
    ],
    confirmPassword: [
        { required: true, message: '请确认密码', trigger: 'blur' },
        { validator: validateConfirmPassword, trigger: 'blur' },
    ],
    phone: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        {
            pattern: /^1[0-9]{10}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
        },
    ],
    email: [
        { required: true, message: '请输入邮箱', trigger: 'blur' },
        {
            pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
            message: '请输入正确的邮箱格式',
            trigger: 'blur',
        },
    ],
    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]

    // compantName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
    // country: [{ required: true, message: '请选择所属国家', trigger: 'change' }],
    // contactInformation: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
    // companyAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }]
};
const backBtn = () => {
    router.push("/login")
}
const country = reactive([
    {
        label: '热门国家',
        options: [{ value: 'China', label: '中国' },]
    },
    {
        label: "所有国家",
        options: [
            { value: "Angola", label: "安哥拉" },
            { value: "Afghanistan", label: "阿富汗" },
            { value: "Albania", label: "阿尔巴尼亚" },
            { value: "Algeria", label: "阿尔及利亚" },
            { value: "Andorra", label: "安道尔共和国" },
            { value: "Anguilla", label: "安圭拉岛" },
            { value: "Antigua and Barbuda", label: "安提瓜和巴布达" },
            { value: "Argentina", label: "阿根廷" },
            { value: "Armenia", label: "亚美尼亚" },
            { value: "Ascension", label: "阿森松" },
            { value: "Australia", label: "澳大利亚" },
            { value: "Austria", label: "奥地利" },
            { value: "Azerbaijan", label: "阿塞拜疆" },
            { value: "Bahamas", label: "巴哈马" },
            { value: "Bahrain", label: "巴林" },
            { value: "Bangladesh", label: "孟加拉国" },
            { value: "Barbados", label: "巴巴多斯" },
            { value: "Belarus", label: "白俄罗斯" },
            { value: "Belgium", label: "比利时" },
            { value: "Belize", label: "伯利兹" },
            { value: "Benin", label: "贝宁" },
            { value: "Bermuda Is", label: "百慕大群岛" },
            { value: "Bolivia", label: "玻利维亚" },
            { value: "Botswana", label: "博茨瓦纳" },
            { value: "Brazil", label: "巴西" },
            { value: "Brunei", label: "文莱" },
            { value: "Bulgaria", label: "保加利亚" },
            { value: "Burkina Faso", label: "布基纳法索" },
            { value: "Burma", label: "缅甸" },
            { value: "Burundi", label: "布隆迪" },
            { value: "Cameroon", label: "喀麦隆" },
            { value: "Canada", label: "加拿大" },
            { value: "Cayman Is", label: "开曼群岛" },
            { value: "Central African Republic", label: "中非共和国" },
            { value: "Chad", label: "乍得" },
            { value: "Chile", label: "智利" },
            { value: "China", label: "中国", disabled: true },
            { value: "Colombia", label: "哥伦比亚" },
            { value: "Congo", label: "刚果" },
            { value: "Cook Is", label: "库克群岛" },
            { value: "Costa Rica", label: "哥斯达黎加" },
            { value: "Cuba", label: "古巴" },
            { value: "Cyprus", label: "塞浦路斯" },
            { value: "Czech Republic", label: "捷克" },
            { value: "Denmark", label: "丹麦" },
            { value: "Djibouti", label: "吉布提" },
            { value: "Dominica Rep", label: "多米尼加共和国" },
            { value: "Ecuador", label: "厄瓜多尔" },
            { value: "Egypt", label: "埃及" },
            { value: "EI Salvador", label: "萨尔瓦多" },
            { value: "Estonia", label: "爱沙尼亚" },
            { value: "Ethiopia", label: "埃塞俄比亚" },
            { value: "Fiji", label: "斐济" },
            { value: "Finland", label: "芬兰" },
            { value: "France", label: "法国" },
            { value: "French Guiana", label: "法属圭亚那" },
            { value: "French Polynesia", label: "法属玻利尼西亚" },
            { value: "Gabon", label: "加蓬" },
            { value: "Gambia", label: "冈比亚" },
            { value: "Georgia", label: "格鲁吉亚" },
            { value: "Ghana", label: "加纳" },
            { value: "Gibraltar", label: "直布罗陀" },
            { value: "Greece", label: "希腊" },
            { value: "Grenada", label: "格林纳达" },
            { value: "Guam", label: "关岛" },
            { value: "Guatemala", label: "危地马拉" },
            { value: "Guinea", label: "几内亚" },
            { value: "Guyana", label: "圭亚那" },
            { value: "Haiti", label: "海地" },
            { value: "Honduras", label: "洪都拉斯" },
            { value: "Hungary", label: "匈牙利" },
            { value: "Iceland", label: "冰岛" },
            { value: "India", label: "印度" },
            { value: "Indonesia", label: "印度尼西亚" },
            { value: "Iran", label: "伊朗" },
            { value: "Iraq", label: "伊拉克" },
            { value: "Ireland", label: "爱尔兰" },
            { value: "Israel", label: "以色列" },
            { value: "Italy", label: "意大利" },
            { value: "Ivory Coast", label: "科特迪瓦" },
            { value: "Jamaica", label: "牙买加" },
            { value: "Japan", label: "日本" },
            { value: "Jordan", label: "约旦" },
            { value: "Kampuchea (Cambodia )", label: "柬埔寨" },
            { value: "Kazakstan", label: "哈萨克斯坦" },
            { value: "Kenya", label: "肯尼亚" },
            { value: "Korea", label: "韩国" },
            { value: "Kuwait", label: "科威特" },
            { value: "Kyrgyzstan", label: "吉尔吉斯坦" },
            { value: "Laos", label: "老挝" },
            { value: "Latvia", label: "拉脱维亚" },
            { value: "Lebanon", label: "黎巴嫩" },
            { value: "Lesotho", label: "莱索托" },
            { value: "Liberia", label: "利比里亚" },
            { value: "Libya", label: "利比亚" },
            { value: "Liechtenstein", label: "列支敦士登" },
            { value: "Lithuania", label: "立陶宛" },
            { value: "Luxembourg", label: "卢森堡" },
            { value: "Madagascar", label: "马达加斯加" },
            { value: "Malawi", label: "马拉维" },
            { value: "Malaysia", label: "马来西亚" },
            { value: "Maldives", label: "马尔代夫" },
            { value: "Mali", label: "马里" },
            { value: "Malta", label: "马耳他" },
            { value: "Mariana Is", label: "马里亚那群岛" },
            { value: "Martinique", label: "马提尼克" },
            { value: "Mauritius", label: "毛里求斯" },
            { value: "Mexico", label: "墨西哥" },
            { value: "Moldova", label: "摩尔多瓦" },
            { value: "Monaco", label: "摩纳哥" },
            { value: "Mongolia", label: "蒙古" },
            { value: "Montserrat Is", label: "蒙特塞拉特岛" },
            { value: "Morocco", label: "摩洛哥" },
            { value: "Mozambique", label: "莫桑比克" },
            { value: "Namibia", label: "纳米比亚" },
            { value: "Nauru", label: "瑙鲁" },
            { value: "Nepal", label: "尼泊尔" },
            { value: "Netheriands Antilles", label: "荷属安的列斯" },
            { value: "Netherlands", label: "荷兰" },
            { value: "New Zealand", label: "新西兰" },
            { value: "Nicaragua", label: "尼加拉瓜" },
            { value: "Niger", label: "尼日尔" },
            { value: "Nigeria", label: "尼日利亚" },
            { value: "North Korea", label: "朝鲜" },
            { value: "Norway", label: "挪威" },
            { value: "Oman", label: "阿曼" },
            { value: "Pakistan", label: "巴基斯坦" },
            { value: "Panama", label: "巴拿马" },
            { value: "Papua New Cuinea", label: "巴布亚新几内亚" },
            { value: "Paraguay", label: "巴拉圭" },
            { value: "Peru", label: "秘鲁" },
            { value: "Philippines", label: "菲律宾" },
            { value: "Poland", label: "波兰" },
            { value: "Portugal", label: "葡萄牙" },
            { value: "Puerto Rico", label: "波多黎各" },
            { value: "Qatar", label: "卡塔尔" },
            { value: "Reunion", label: "留尼旺" },
            { value: "Romania", label: "罗马尼亚" },
            { value: "Russia", label: "俄罗斯" },
            { value: "Saint Lueia", label: "圣卢西亚" },
            { value: "Saint Vincent", label: "圣文森特岛" },
            { value: "Samoa Eastern", label: "东萨摩亚(美)" },
            { value: "Samoa Western", label: "西萨摩亚" },
            { value: "San Marino", label: "圣马力诺" },
            { value: "Sao Tome and Principe", label: "圣多美和普林西比" },
            { value: "Saudi Arabia", label: "沙特阿拉伯" },
            { value: "Senegal", label: "塞内加尔" },
            { value: "Seychelles", label: "塞舌尔" },
            { value: "Sierra Leone", label: "塞拉利昂" },
            { value: "Singapore", label: "新加坡" },
            { value: "Slovakia", label: "斯洛伐克" },
            { value: "Slovenia", label: "斯洛文尼亚" },
            { value: "Solomon Is", label: "所罗门群岛" },
            { value: "Somali", label: "索马里" },
            { value: "South Africa", label: "南非" },
            { value: "Spain", label: "西班牙" },
            { value: "SriLanka", label: "斯里兰卡" },
            { value: "St.Lucia", label: "圣卢西亚" },
            { value: "St.Vincent", label: "圣文森特" },
            { value: "Sudan", label: "苏丹" },
            { value: "Suriname", label: "苏里南" },
            { value: "Swaziland", label: "斯威士兰" },
            { value: "Sweden", label: "瑞典" },
            { value: "Switzerland", label: "瑞士" },
            { value: "Syria", label: "叙利亚" },
            { value: "Tajikstan", label: "塔吉克斯坦" },
            { value: "Tanzania", label: "坦桑尼亚" },
            { value: "Thailand", label: "泰国" },
            { value: "Togo", label: "多哥" },
            { value: "Tonga", label: "汤加" },
            { value: "Trinidad and Tobago", label: "特立尼达和多巴哥" },
            { value: "Tunisia", label: "突尼斯" },
            { value: "Turkey", label: "土耳其" },
            { value: "Turkmenistan", label: "土库曼斯坦" },
            { value: "Uganda", label: "乌干达" },
            { value: "Ukraine", label: "乌克兰" },
            { value: "United Arab Emirates", label: "阿拉伯联合酋长国" },
            { value: "United Kiongdom", label: "英国" },
            { value: "United States of America", label: "美国" },
            { value: "Uruguay", label: "乌拉圭" },
            { value: "Uzbekistan", label: "乌兹别克斯坦" },
            { value: "Venezuela", label: "委内瑞拉" },
            { value: "Vietnam", label: "越南" },
            { value: "Yemen", label: "也门" },
            { value: "Yugoslavia", label: "南斯拉夫" },
            { value: "Zimbabwe", label: "津巴布韦" },
            { value: "Zaire", label: "扎伊尔" },
            { value: "Zambia", label: "赞比亚" }
        ]
    }
])


const sendVerificationCode = () => {
    // 检查是否输入了邮箱
    if (!registerForm.email) {
        ElMessage.warning('请先输入邮箱');
        return;
    }
    sendCode({ email: registerForm.email }).then(res => {

        if (res.data.code == 200) {
            ElMessage.success('发送验证码成功');
            // 启动倒计时
            canSendCode.value = false;
            const timer = setInterval(() => {
                countdown.value--;
                if (countdown.value <= 0) {
                    clearInterval(timer);
                    canSendCode.value = true;
                    countdown.value = 60;
                }
            }, 1000);
        } else {
            ElMessage.error(res.data.msg);
            return
        }
    })

}

const registerBtn = () => {
    // 检查是否有必填字段为空
    const emptyFields = Object.keys(registerForm).filter(
        key => rules[key] && rules[key].some(rule => rule.required) && !registerForm[key]
    );

    if (emptyFields.length > 0) {
        // 有必填字段为空，提示用户并阻止注册
        ElMessage.error('请填写所有必填字段');
        return;
    }
    // if (!registerForm.logo) {
    //     ElMessage.error('请上传公司logo');
    //     return
    // }
    let obj = {
        userName: registerForm.useName,
        password: registerForm.password,
        phonenumber: registerForm.phone,
        email: registerForm.email,
        code: registerForm.code,
    }
    register(obj).then(res => {
        if (res.data.code == 200) {
            ElMessage({
                message: '注册成功',
                type: 'success',
            })
            router.push("/login")
        } else {
            ElMessage.error(res.data.msg)
        }
    })
}

const handleExceed = (files, fileList) => {
    ElMessage.warning('超出文件数量限制！');
}
const beforeUpload = (file) => {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isJPG && !isPNG) {
        ElMessage.error('上传头像图片只能是 JPG/PNG 格式!');
    }
    if (!isLt2M) {
        ElMessage.error('上传头像图片大小不能超过 2MB!');
    }
    return isJPG || isPNG && isLt2M;
};

const handleSuccess = (response, file, fileList) => {
    registerForm.logo = response.data.url
};

</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.login_header {
    /* height: 80px; */
    display: flex;
    padding-bottom: 15px;
    justify-content: space-around;
}

.logo {
    width: 84px;
    height: 69px;
    margin-top: 15px;
}

.dengluBtn {
    background-color: #F7B02D;
    color: #333;
    /* width: 113px; */
    height: 43px;
    font-weight: 700;
    border: 0;
    padding: 0 10px;
    margin-top: 29px;
}

.trends {
    height: 179px;
    background: url("../../assets/img/login_bg.png") no-repeat;
    background-size: 100% 100%;
    text-align: left;
    padding-left: 440px;
    padding-top: 48px;
}

.kehuzhuce {
    text-align: left;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #002FA7;
    /* width: 72px; */
    border-bottom: 1px solid #467DEF;
    padding-bottom: 20px;
}

.information {
    /* height: 362px; */
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    margin-top: 27px;
    overflow: hidden;
    padding-bottom: 32px;
}

.title {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    text-align: left;
    margin-top: 20px;
    margin-left: 42px;
    border-bottom: 1px solid #DDDDDD;
    padding-bottom: 12px;
    margin-right: 39px;
}

::v-deep .el-input {
    width: 246px;
    height: 38px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
}

::v-deep .el-form-item__label {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
}

::v-deep .el-form-item {
    margin-top: 20px;
}

.yanzhengBtn {
    width: 96px;
    height: 38px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-left: 19px;
}

.upload {
    width: 131px;
    height: 38px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #DDDDDD;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}

.register_bottom {
    height: 81px;
    background-color: #fff;
}

.register_bottom {
    height: 81px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    margin-top: 17px;
    display: flex;
}

.shenheBtn {
    width: 300px;
    height: 40px;
    background: #002FA7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FEFEFE;
    margin-left: 67px;
    margin-top: 23px;
}

::v-deep .el-message {
    padding: 10px;
}
</style>
